// ============================================================
// 签到 API
// ============================================================

import { get, post } from '../client'
import type { ApiResponse } from '@task-bazaar/shared'

// ─── 签到 ───────────────────────────────────────────────────

export interface SignInResult {
  consecutiveDays: number
  reward: number
  message: string
}

export function signIn() {
  return post<ApiResponse<SignInResult>>('/sign-in')
}

// ─── 签到日历 ───────────────────────────────────────────────

export interface CalendarResult {
  month: string
  signedDays: number[]
  consecutiveDays: number
  todaySigned: boolean
}

export function getCalendar(month: string) {
  return get<ApiResponse<CalendarResult>>('/sign-in/calendar', { params: { month } })
}

// ─── 签到规则 ───────────────────────────────────────────────

export interface SignInRule {
  day: number
  reward: number
}

export function getRules() {
  return get<ApiResponse<SignInRule[]>>('/sign-in/rules')
}
